<div>
  <div class="retour oneLine mt-1">
    <span>&#60;</span>
    <button (click)="retour()">{{ preferenceMessages.tab_2_retour | translate }}</button>
  </div>
  <div class="mt-3">
    <div class="oneLine" *ngIf="action === 'ajouter'">
      <h2>{{ preferenceMessages.tab_1_label_8 | translate }}</h2>
      <app-partage-preference (preferenceCopied)="partageReturn($event)"></app-partage-preference>
    </div>
    <h2 *ngIf="action === 'modifier'">{{ preferenceMessages.tab_1_label_9 | translate }}</h2>
  </div>
  <div class="content">
    <div class="tableau">
      <h3>{{ choixSupport.libelleChoix | translate }}</h3>
      <app-tableau-diffuseur *ngIf="chargeTableau" (formOutput)="getActionOnTab($event)" (presseOutput)="getActionOnPresse($event)"  [mode]="2" [tableContent]="tableContent"
        [form]="form"></app-tableau-diffuseur>
    </div>
    <div class="form">
      <h3 *ngIf="action === 'ajouter'">{{ preferenceMessages.tab_1_label_10 | translate }}</h3>
      <h3 *ngIf="action === 'modifier'">{{ preferenceMessages.tab_1_label_11 | translate }}</h3>
      <div class="oneLine mt-3">
        <p>{{ preferenceMessages.tab_2_label_6_part1 | translate }}</p>
        <p class="red">&nbsp;*&nbsp;</p>
        <p>{{ preferenceMessages.tab_2_label_6_part2 | translate }}</p>
      </div>
      <form class="myForm" [formGroup]="myForm">
        <div id="intitule">
          <app-form-input [parentForm]="myForm" [label]="preferenceMessages.tab_2_label_intitule | translate"
            [type]="'text'" [rule]="'required'" [name]="'preference_SepAtt_diffuseur_SepAtt_intitule'">
          </app-form-input>
        </div>
        <div id="etiquette-group" class="mt-3 mb-2">
          <div *ngFor="let item of diffuseursList" class="etiquette">
            <span class="text-etiquette">{{getLabelEtiquette(item)}}</span>
            <div class="icon-etiquette">
              <mat-icon class="delete-icon" (click)="delete(item)">highlight_off</mat-icon>
            </div>
          </div>
        </div>
        <button *ngIf="action === 'ajouter'" [disabled]="(!myForm.valid)" (click)="savePref()" class="btn btn-primary">
          {{ preferenceMessages.tab_4_label_ajouter | translate }}
        </button>
        <button *ngIf="action === 'modifier'" [disabled]="(!myForm.valid)" (click)="savePref()" class="btn btn-primary">
          {{ preferenceMessages.tab_4_label_modifier | translate }}
        </button>
        <button id="annuler" (click)="annuler()" class="btn btn-outline-primary ml-2">
          {{ preferenceMessages.tab_4_label_annuler | translate }}
        </button>
      </form>
    </div>
  </div>
</div>
